import { Box, Typography, styled } from "@mui/material";
import { StyledButton } from "react-common-ui-library";

export const StyledVerificationMethodOptionalTextAlign = styled(Box)(
  ({ theme }) => ({
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  })
);

export const StyledVerificationMethodOptionalText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isOptional",
})(({ theme, isOptional }) => ({
  fontStyle: "italic",
  letterSpacing: "0.5px",
  paddingLeft: isOptional && theme.spacing(2),
  alignSelf: "center",
  color: theme.palette.text.secondary,
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "0",
  },
}));

export const LoginVerificationMethodsContactWrapper = styled(Typography)(
  ({ theme }) => ({
    "& .MuiDivider-root": {
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2.4, 0),
      },
    },
  })
);

export const StyledCheckIconPreferredContactDesktopBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "preferredContact" || prop !== "isPhone",
})(({ theme, preferredContact, isPhone }) => ({
  "& .MuiSvgIcon-root": {
    display: "block",
    fill: preferredContact
      ? theme.palette.success.misc.check
      : theme.palette.text.secondary,
    marginRight: theme.spacing(1),
    width: (preferredContact && "24px") || (isPhone && "18px") || "24px",
    height: (preferredContact && "28px") || (isPhone && "28px") || "30px",
  },
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const StyledCheckIconPreferredContactMobileBox = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "preferredContact" || prop !== "isPhone",
})(({ theme, preferredContact, isPhone }) => ({
  [theme.breakpoints.up("sm")]: {
    "& .MuiSvgIcon-root": {
      display: "none",
    },
  },
  [theme.breakpoints.down("sm")]: {
    display: "inline",
    "& .MuiSvgIcon-root": {
      display: "inline",
      fill: preferredContact
        ? theme.palette.success.misc.check
        : theme.palette.text.secondary,
      marginRight: theme.spacing(1),
      width: (preferredContact && "24px") || (isPhone && "18px") || "24px",
      height: "35px",
    },
  },
}));

export const StyledVerificationMethodsWrapperBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 3),
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2, 0),
    flexDirection: "column",
  },
}));

export const StyledVerificationMethodCheckAndTextBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isEmailOrPhoneText",
})(({ isEmailOrPhoneText, theme }) => ({
  display: "flex",
  "& .MuiTypography-root": {
    alignSelf: isEmailOrPhoneText ? "center" : "inherit",
  },
  "& .MuiIconButton-root": {
    padding: theme.spacing(0, 1),
  },
}));

export const StyledCheckboxWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  "& .MuiCheckbox-root": {
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-start",
    },
  },
  "& .MuiTypography-root": {
    paddingLeft: theme.spacing(1.2),
    alignSelf: "center",
  },
}));

export const StyledVerificationEditRemoveBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignSelf: "flex-start",
  "& .MuiSvgIcon-root": {
    fill: theme.palette.info.light,
    marginRight: theme.spacing(0),
    width: "20px",
    height: "19px",
  },
  "& .MuiDivider-root": {
    margin: theme.spacing(0, 1),
    alignSelf: "center",
    height: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: theme.spacing(2),
  },
}));

export const StyledVerificationMethodButtonWrapper = styled(Box)(
  ({ theme }) => ({
    width: "50%",
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    marginTop: theme.spacing(10),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: theme.spacing(6),
    },
  })
);

export const StyledVerificationMethodTextButtonWrapper = styled(Box)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    marginTop: theme.spacing(4),
  })
);

export const StyledChangePreferredVerificationButton = styled(StyledButton)(
  ({ theme }) => ({
    marginBottom: theme.spacing(7),
  })
);
